<template>
  <global-dialog-card
    v-model="model"
    :title="payment ? payment.period : $t('finance_payment_fallback_title')"
    hide-actions
    max-width="420"
  >
    <div v-if="payment">
      <p class="detail-amount">{{ formatCurrency(payment.amount) }}</p>

      <div class="detail-rows">
        <div class="detail-row">
          <span>{{ $t("finance_date") }}</span>
          <strong>{{ localeDate(payment.date) }}</strong>
        </div>
        <div v-if="payment.note" class="detail-row">
          <span>{{ $t("finance_comment") }}</span>
          <strong>{{ payment.note }}</strong>
        </div>
      </div>
    </div>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import GlobalDialogCard from "@/components/global/GlobalDialogCard.vue";

export default {
  name: "PlatformPaymentDetailDialog",

  components: { GlobalDialogCard },

  mixins: [hasModel],

  props: {
    payment: { type: Object, default: null },
  },

  methods: {
    formatCurrency(amount) {
      const value = Number(amount) || 0;
      return `${value.toFixed(2)} ${this.restaurantCurrency}`;
    },
  },
};
</script>

<style scoped>
.detail-amount {
  margin: 0 0 16px;
  font-size: 1.4rem;
  font-weight: 800;
}

.detail-rows {
  display: grid;
  gap: 8px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.88rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
